import React from 'react';
import _ from 'underscore';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleUp } from '@fortawesome/free-regular-svg-icons'

import './NMOption.scss';

class FsdsaiOption extends React.Component {
  render() {
    const track = _.find(this.props.tracks, track => track.attributes.long_symbol === this.props.track_long_symbol);
    if (!track) { return null; }

    const immersiveOption = _.find(track.relationships.price_options.data, po => po.attributes.name === 'immersive');
    const personalizedOption = _.find(track.relationships.price_options.data, po => po.attributes.name === 'personalized');

    return (
      <Link to={`/enroll?track=fsdsai`} style={{ textDecoration: 'none' }} className='nm-card d-block hovercraft rounded'>
        <div className="info ai-card bg-white mt-3 rounded hovercraft">
          <p className=" mb-0"><span><FontAwesomeIcon icon={faArrowAltCircleUp} color="#bf9b30" /> <b>Upgrade</b> FSWD to include Python, Data Science, AI Application, TypeScript and more.</span></p>

          <div style={{ fontSize: '0.9em' }}>
            <div className='d-flex justify-content-between option upgrade'>
              <b>Upgrade to FSDSAI</b>
              <div> +$500 </div>
            </div>
          </div>
        </div>
      </Link>
    );
  }
}

export default FsdsaiOption;
